import React from 'react';
import './Boost.css';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed
import { useLanguage } from '../../LanguageContext';

function Powerful() {
  const { language } = useLanguage();

  return (
    <div className='learn center boost-container' style={{ backgroundColor: 'white' }}>
      <span className={`Powerful3 ${language === 'es' ? 'spanish-styling' : ''}`}>
        <TranslateText text="POWERFUL PACKAGES TO BOOST YOUR CREDIT SCORE FAST." />
      </span>
      <div className="separator2"></div>
    </div>
  );
}

export default Powerful;


// import React from 'react'
// import './Boost.css'
// function Powerful() {
//   return (
//     <div className='learn center boost-container' style={{ backgroundColor: 'white' }}>
//         <span className="Powerful3">POWERFUL PACKAGES TO BOOST YOUR CREDIT SCORE FAST. </span>
       
//         <div className="separator2"></div>

//     </div>
//   )
// }

// export default Powerful

